import { Heading } from '@astryxdesign/core/Heading';
import { Text } from '@astryxdesign/core/Text';
import { VStack, HStack } from '@astryxdesign/core/Stack';
import { Button } from '@astryxdesign/core/Button';
import { Section } from '@astryxdesign/core/Section';
import { Photo } from '@/components/Photo';
import { EmptyView } from '@/components/StateViews';
import { money } from '@/lib/money';
import { durationLabel } from '@/lib/time';
import { useBookingRoute, useLoadedTenant } from './hooks';

export function ServicesPage() {
  const t = useLoadedTenant();
  const { go } = useBookingRoute();
  const groups = new Map<string, typeof t.services>();
  for (const s of t.services) {
    const key = s.category || 'Услуги';
    groups.set(key, [...(groups.get(key) ?? []), s]);
  }

  return (
    <Section variant="transparent" padding={4} paddingBlockStart={6}>
      <VStack gap={6}>
        <VStack gap={1}>
          <Heading level={1}>Услуги</Heading>
          <Text color="secondary">Цена и время работы указаны для одной машины. Время в студии считается в часовом поясе студии.</Text>
        </VStack>
        {t.services.length === 0 ? (
          <EmptyView title="Услуги пока не добавлены" description="Позвоните в студию, чтобы записаться." />
        ) : null}
        {[...groups].map(([category, list]) => (
          <VStack key={category} gap={3}>
            {groups.size > 1 ? <Heading level={2}>{category}</Heading> : null}
            <ul className="grid gap-3">
              {list.map((s) => (
                <li key={s.id} className="overflow-hidden rounded-lg border border-border bg-surface">
                  {s.photo_path ? <Photo path={s.photo_path} alt={s.name} className="aspect-video w-full" /> : null}
                  <VStack gap={2} padding={4}>
                    <HStack justify="between" align="start" gap={3}>
                      <Text weight="semibold" type="large">
                        {s.name}
                      </Text>
                      <Text weight="semibold" hasTabularNumbers textWrap="nowrap">
                        {money(s.price_cents, t.currency, s.price_is_from)}
                      </Text>
                    </HStack>
                    {s.description ? <Text color="secondary">{s.description}</Text> : null}
                    <HStack justify="between" align="center" gap={3}>
                      <Text color="secondary">{durationLabel(s.duration_minutes)}</Text>
                      <Button
                        label="Выбрать время"
                        variant={s.resource_count > 0 ? 'primary' : 'secondary'}
                        isDisabled={s.resource_count === 0}
                        tooltip={s.resource_count === 0 ? 'Сейчас нет свободного поста для этой услуги' : undefined}
                        onClick={() => go('time', { svc: s.id })}
                      />
                    </HStack>
                  </VStack>
                </li>
              ))}
            </ul>
          </VStack>
        ))}
      </VStack>
    </Section>
  );
}
